var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.54518 4.87868C2.6665 5.75736 2.6665 7.17157 2.6665 10V22C2.6665 24.8284 2.6665 26.2426 3.54518 27.1213C4.42386 28 5.83808 28 8.6665 28H23.3332C26.1616 28 27.5758 28 28.4545 27.1213C29.3332 26.2426 29.3332 24.8284 29.3332 22V10C29.3332 7.17157 29.3332 5.75736 28.4545 4.87868C27.5758 4 26.1616 4 23.3332 4H8.6665C5.83808 4 4.42386 4 3.54518 4.87868ZM21.3332 11C21.8855 11 22.3332 11.4477 22.3332 12V22.6667C22.3332 23.219 21.8855 23.6667 21.3332 23.6667C20.7809 23.6667 20.3332 23.219 20.3332 22.6667V12C20.3332 11.4477 20.7809 11 21.3332 11ZM11.6665 14.6667C11.6665 14.1144 11.2188 13.6667 10.6665 13.6667C10.1142 13.6667 9.6665 14.1144 9.6665 14.6667V22.6667C9.6665 23.219 10.1142 23.6667 10.6665 23.6667C11.2188 23.6667 11.6665 23.219 11.6665 22.6667L11.6665 14.6667ZM16.9998 17.3333C16.9998 16.781 16.5521 16.3333 15.9998 16.3333C15.4476 16.3333 14.9998 16.781 14.9998 17.3333V22.6667C14.9998 23.219 15.4476 23.6667 15.9998 23.6667C16.5521 23.6667 16.9998 23.219 16.9998 22.6667V17.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/barChart.9547fef4baa42f1c8bbfa1a9cd5a8c35.svg";
export { ForwardRef as ReactComponent };